import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { useSelector } from "react-redux";

import { getVendor } from "src/store/vendor/selector";

const style: React.CSSProperties = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "block",
};

function VendorNameCell({ vendorId }: { vendorId: string | undefined }) {
  const vendor = useSelector((s: any) => getVendor(s, vendorId))?.name || "";
  return (
    <Tooltip title={vendor}>
      <span style={style}>{vendor}</span>
    </Tooltip>
  );
}

export default VendorNameCell;
